// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-2qzev","content":"content-3rade","controls":"controls-25_Yw"};